export type WorkspaceAdmissionShellVariant =
  'thread' | 'design' | 'files' | 'generic';

/**
 * Which placeholder the workspace boundary shows while it admits the user.
 * Only routes that share the default thread sidebar width get a sidebar
 * shell (threads, the design home, and Drive: files, drives and Trash, whose
 * rail and Files panel use the same width); every other workspace route
 * keeps the plain full-screen loader, because its layout differs.
 */
const DRIVE_ROUTES = new Set(['files', 'drives', 'trash']);

export function resolveWorkspaceAdmissionShellVariant(
  pathname: string | null | undefined
): WorkspaceAdmissionShellVariant {
  const segments = (pathname ?? '').split('/').filter(Boolean);
  if (segments.length < 2) return 'generic';
  if (segments[1] === 'threads' && segments.length >= 3) return 'thread';
  if (segments[1] === 'design' && segments.length === 2) return 'design';
  if (DRIVE_ROUTES.has(segments[1] ?? '')) return 'files';
  return 'generic';
}
